import { JSX, useContext } from "react";
import { useHistory } from "react-router-dom";
import { ExportFormatType, ExportGapFilterType, ExportProviderAvailabilityType, ReportFormatType, NetworkProviderFilterType } from "@app/exports/enumerations";
import * as helpers from "@app/exports/export-panel-body/exportPanelBodyHelpers";
import { ExportAdequacyServicingProvidersModel } from "@app/exports/exportModels";
import { NetworkAssessmentAnalysisType, NextClosestProviderAction, PatientVolumeLabelEnum } from "@app/projects/enumerators";
import { toast, TypeOptions } from "react-toastify";
import { ProviderNetworkTypeEnum } from "@app/shared/enums/providerNetworkTypeEnum";
import ExportService from "@app/exports/exportService";
import { CountyProjectContext } from "@app/projects/CountyProjectContext";
import { QESButton } from "@app/shared/qes-standards/Button";

const ClaimsActivityDownloadGhostProviders = (): JSX.Element => {
  const projectContext = useContext(CountyProjectContext);
  const history = useHistory();

  const onDownloadGhostProvidersClick = async (): Promise<void> => {
    const reportName: string = helpers.reportName(PatientVolumeLabelEnum[PatientVolumeLabelEnum.Ghost] + "_Providers");

    const servicingProviderModel: ExportAdequacyServicingProvidersModel = {
      appendPatternOfCareProviders: false,
      comparedProjectRunConfigurationId: null,
      customProjectId: projectContext.project.projectId,
      eMailOnSuccess: false,
      exportName: reportName,
      formatType: ExportFormatType.CSV,
      hsdFormat: ReportFormatType.Default,
      impactProviderType: ExportProviderAvailabilityType.All,
      includeActiveRegionSets: true,
      includeApprovedRegionSets: true,
      includeFacilitySpecialties: true,
      includePendingRegionSets: true,
      includePhysicianSpecialties: true,
      isZipAnalysis: false,
      networkAssessmentAnalysisTypes: [NetworkAssessmentAnalysisType.ServiceArea],
      networkProviderFilterType: NetworkProviderFilterType.Available,
      nextClosestProviderAction: NextClosestProviderAction.None,
      projectRunConfigurationId: projectContext.project.projectRunConfigurations[0].projectRunConfigurationId,
      projectURL: history.location.pathname + history.location.search,
      providerClaimsVolumeFilter: PatientVolumeLabelEnum.Ghost,
      providerComparisonTypes: [],
      providerIds: [],
      providerNetworkType: ProviderNetworkTypeEnum.Network,
      regionSetGapFilter: ExportGapFilterType.All,
      regionSetIds: [],
      runAsynchronous: true,
      specialtyGapFilter: ExportGapFilterType.All,
      specialtyGroupCodes: [],
    };

    let response = 0;
    try {
      const exportService = new ExportService();
      response = await exportService.postExportAdequacyServicingProviders(servicingProviderModel);
    }
    catch (error) {
      response = 0;
    }

    handleToast(response);
  }

  const handleToast = (response: number) => {
    let newStatus = "";
    let toastType: TypeOptions = "default";

    if (response === 0) {
      newStatus = "There was an error submitting the report. Please try again, or contact your Client Services Representative.";
      toastType = "error";

      toast(newStatus, {
        autoClose: false,
        containerId: "z-index-9999",
        type: toastType,
      });
    } else {
      newStatus = "Report submitted!";
      toastType = "success";

      toast(newStatus, {
        containerId: "z-index-9999",
        type: toastType,
      });
    }
  }

  return (
    <QESButton
      className="text-info float-end"
      onClick={() => onDownloadGhostProvidersClick()}
      qesTestId="claims-activity__download-ghost-providers--download"
      qesType="secondary"
    >
      Download Ghost Providers
    </QESButton>
  )
}

export default ClaimsActivityDownloadGhostProviders;